// import fun
const _import = require('../_import')
// scope 
const scope = 'table'

export default {
    path: '/table',
      name: 'table',
      component: _import(`${scope}`),
      children: [
        {
          path: 'accountReceivable',
          name: 'accountReceivable',
          component: _import(`${scope}/accountReceivable`)
        }
      ]

}



// WEBPACK FOOTER //
// ./src/router/modules/table.js